module.exports = __webpack_public_path__ + "img/Camera_Transforms.a474c59f.png";